import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';

const Container = styled.div`
  width: 500px;
  margin: 10px;
  height:100%;
  font-size: 13px;
  font-family: 'Poppins', 'sans-serif';
  color: white;
`;

export default function TextAreaDescripcion(props) {
  const { label, value, estado, action } = props;
  const dispatch = useDispatch();
  const [localValue, setLocalValue] = useState(value);

  
  
  const handleChange = (e) => {
  	
    setLocalValue(e.target.value);
    dispatch(action({ [label]: e.target.value }));
  };

  useEffect(()=>{
    setLocalValue(value);
    if (estado===2){
       dispatch(action({ descripcion: document.getElementById(label).value }));
    }
  },[value,estado,action,dispatch,label])

  return (
    <Container>
      <div>
        <label htmlFor={label}><b>{label}</b></label>
        <TextField
          fullWidth
          multiline
          rows="28"
          id={label}
          value={localValue}
          onChange={handleChange}
          disabled={estado === 0}
        />
      </div>
    </Container>
  );
}









